// Traducciones de la interfaz de usuario
// {term}     → nombre de la categoría (las comillas «» se añaden en el render)
// {articulo} → "un" / "una" según género — solo relevante en español
// {nombre}   → nombre del archivo de video

export type ClaveUI =
  | 'frasesBaja'
  | 'frasesMedia'
  | 'frasesAlta'
  | 'frasesBajaPasada'
  | 'frasesMediaPasada'
  | 'frasesAltaPasada'
  | 'umbralBaja'
  | 'umbralMedia'
  | 'umbralAlta'
  | 'modoArchivo'
  | 'modoRastro'
  | 'volverArchivo'
  | 'enOtrasLenguas'
  | 'sinImagenes'
  | 'cargandoVocabulario'
  | 'maquinaLista'
  | 'cargandoArchivo'
  | 'observando'
  | 'presionarPlay';

export type TraduccionesUI = Record<ClaveUI, string>;

export const idiomaDefecto = 'es';

export const ui: Record<string, TraduccionesUI> = {
  es: {
    frasesBaja: 'Me cuesta nombrarlo. ¿Quizás {articulo} {term}?',
    frasesMedia: 'Creo que veo {articulo} {term} aquí.',
    frasesAlta: 'Estoy bastante seguro de que esto es {articulo} {term}.',
    frasesBajaPasada: 'Me costó nombrarlo. ¿Quizás {articulo} {term}?',
    frasesMediaPasada: 'Creí ver {articulo} {term} aquí.',
    frasesAltaPasada: 'Estuve bastante seguro de que vi {articulo} {term}.',
    umbralBaja: '0-40% · baja',
    umbralMedia: '40-70% · media',
    umbralAlta: '70-100% · alta',
    modoArchivo: 'Archivo',
    modoRastro: 'Rastro',
    volverArchivo: '← volver al archivo',
    enOtrasLenguas: 'en otras lenguas',
    sinImagenes: 'Sin imágenes cargadas para esta categoría.',
    cargandoVocabulario: 'Cargando vocabulario — 80 palabras para nombrar el mundo...',
    maquinaLista: 'La máquina está lista. Iniciando archivo...',
    cargandoArchivo: 'Cargando archivo: {nombre}',
    observando: 'Observando...',
    presionarPlay: 'Presione play para comenzar.',
  },

  fr: {
    frasesBaja: "J'ai du mal à nommer ça. Peut-être un {term} ?",
    frasesMedia: 'Je crois voir un {term} ici.',
    frasesAlta: "Je suis assez certain que c'est un {term}.",
    frasesBajaPasada: "J'ai eu du mal à nommer ça. Peut-être un {term} ?",
    frasesMediaPasada: "J'ai cru voir un {term} ici.",
    frasesAltaPasada: "J'étais assez certain d'avoir vu un {term}.",
    umbralBaja: '0-40% · faible',
    umbralMedia: '40-70% · moyen',
    umbralAlta: '70-100% · élevé',
    modoArchivo: 'Archive',
    modoRastro: 'Trace',
    volverArchivo: '← retour aux archives',
    enOtrasLenguas: "en d'autres langues",
    sinImagenes: 'Aucune image chargée pour cette catégorie.',
    cargandoVocabulario: 'Chargement du vocabulaire — 80 mots pour nommer le monde...',
    maquinaLista: "La machine est prête. Démarrage de l'archive...",
    cargandoArchivo: 'Chargement du fichier : {nombre}',
    observando: 'Observation...',
    presionarPlay: 'Appuyez sur play pour commencer.',
  },

  pt: {
    frasesBaja: 'Tenho dificuldade em nomear isso. Talvez um {term}?',
    frasesMedia: 'Acho que vejo um {term} aqui.',
    frasesAlta: 'Tenho bastante certeza de que isso é um {term}.',
    frasesBajaPasada: 'Tive dificuldade em nomear isso. Talvez um {term}?',
    frasesMediaPasada: 'Achei que vi um {term} aqui.',
    frasesAltaPasada: 'Estive bastante certo de que vi um {term}.',
    umbralBaja: '0-40% · baixa',
    umbralMedia: '40-70% · média',
    umbralAlta: '70-100% · alta',
    modoArchivo: 'Arquivo',
    modoRastro: 'Rastro',
    volverArchivo: '← voltar ao arquivo',
    enOtrasLenguas: 'em outras línguas',
    sinImagenes: 'Sem imagens carregadas para esta categoria.',
    cargandoVocabulario: 'Carregando vocabulário — 80 palavras para nomear o mundo...',
    maquinaLista: 'A máquina está pronta. Iniciando arquivo...',
    cargandoArchivo: 'Carregando arquivo: {nombre}',
    observando: 'Observando...',
    presionarPlay: 'Pressione play para começar.',
  },

  ln: {
    frasesBaja: 'Nakoki te koluka nkombo. Mopé {term}?',
    frasesMedia: 'Nakanisi komona {term} awa.',
    frasesAlta: 'Nateyemaki ete oyo ezali {term}.',
    frasesBajaPasada: 'Nakomeli malamu te. Mopé {term}?',
    frasesMediaPasada: 'Nakanisaki komona {term} awa.',
    frasesAltaPasada: 'Nateyemaki ete oyo ezalaki {term}.',
    umbralBaja: '0-40% · mike',
    umbralMedia: '40-70% · kati',
    umbralAlta: '70-100% · mingi',
    modoArchivo: 'Mokanda',
    modoRastro: 'Mpela',
    volverArchivo: '← zonga na mokanda',
    enOtrasLenguas: 'na bilinga mosusu',
    sinImagenes: 'Bilili ezali te mpo na kategoria oyo.',
    cargandoVocabulario: 'Kobomba maloba — maloba 80 mpo na kobenga mokili...',
    maquinaLista: 'Masini ezali liké. Kotanga mokanda...',
    cargandoArchivo: 'Kobomba fisiye: {nombre}',
    observando: 'Kotala...',
    presionarPlay: 'Sosa play mpo na kobanda.',
  },

  sw: {
    frasesBaja: 'Ninashindwa kulitaja. Labda ni {term}?',
    frasesMedia: 'Nafikiri ninaona {term} hapa.',
    frasesAlta: 'Niko karibu na uhakika kwamba hii ni {term}.',
    frasesBajaPasada: 'Nilishindwa kulitaja. Labda ilikuwa {term}?',
    frasesMediaPasada: 'Nilidhani niliiona {term} hapa.',
    frasesAltaPasada: 'Nilikuwa na uhakika kwamba ilikuwa {term}.',
    umbralBaja: '0-40% · chini',
    umbralMedia: '40-70% · kati',
    umbralAlta: '70-100% · juu',
    modoArchivo: 'Kumbukumbu',
    modoRastro: 'Kufuatilia',
    volverArchivo: '← rudi kwenye kumbukumbu',
    enOtrasLenguas: 'katika lugha nyingine',
    sinImagenes: 'Hakuna picha zilizopakiwa kwa kategoria hii.',
    cargandoVocabulario: 'Kupakia msamiati — maneno 80 ya kutaja ulimwengu...',
    maquinaLista: 'Mashine iko tayari. Kuanza kumbukumbu...',
    cargandoArchivo: 'Kupakia faili: {nombre}',
    observando: 'Kuangalia...',
    presionarPlay: 'Bonyeza play kuanza.',
  },

  rw: {
    frasesBaja: 'Biranzica kubitera izina. Birashoboka {term}?',
    frasesMedia: 'Ntekereza ko mbona {term} hano.',
    frasesAlta: 'Nizeye ko ibi ari {term}.',
    frasesBajaPasada: 'Byarangoye kubitera izina. Birashoboka yari {term}?',
    frasesMediaPasada: 'Ntekereje ko nabonye {term} hano.',
    frasesAltaPasada: 'Nizeye ko nabonye {term}.',
    umbralBaja: '0-40% · make',
    umbralMedia: '40-70% · hagati',
    umbralAlta: '70-100% · cyane',
    modoArchivo: 'Ububiko',
    modoRastro: 'Inzira',
    volverArchivo: '← subira ku bubiko',
    enOtrasLenguas: 'mu zindi ndimi',
    sinImagenes: 'Nta mafoto yashyizweho kuri iyi kategori.',
    cargandoVocabulario: 'Gutangira inyandiko — amagambo 80 yo kwita isi...',
    maquinaLista: 'Imashini iri itegura. Gutangira ububiko...',
    cargandoArchivo: 'Gufungura dosiye: {nombre}',
    observando: 'Kureba...',
    presionarPlay: 'Kanda play gutangira.',
  },

  kg: {
    frasesBaja: 'Kimonaka te nkombo. Mbala {term}?',
    frasesMedia: 'Nkimonaka {term} awa.',
    frasesAlta: 'Nzabu ete yandi yena {term}.',
    frasesBajaPasada: 'Kimonaka te nkombo. Mbala yandi yena {term}?',
    frasesMediaPasada: 'Nkimonaka {term} awa kuna.',
    frasesAltaPasada: 'Nzabukaka ete yandi yena {term}.',
    umbralBaja: '0-40% · fioti',
    umbralMedia: '40-70% · katikati',
    umbralAlta: '70-100% · mingi',
    modoArchivo: 'Makanda',
    modoRastro: 'Ntalu',
    volverArchivo: '← zonga ko makanda',
    enOtrasLenguas: 'mu ndinga zingana',
    sinImagenes: 'Bifwanisu biena te mpi kategoria yena.',
    cargandoVocabulario: 'Yantika maloba — maloba 80 ya kubika nkombo nza...',
    maquinaLista: 'Masini ena diaka. Yantika makanda...',
    cargandoArchivo: 'Yantika fisiye: {nombre}',
    observando: 'Talanga...',
    presionarPlay: 'Suna play mpo ya kubanda.',
  },

  yo: {
    frasesBaja: 'Mo ń ṣòro láti pe orúkọ rẹ̀. Bóyá {term}?',
    frasesMedia: 'Mo rò pé mo rí {term} níbí.',
    frasesAlta: 'Mo dájú díẹ̀ pé èyí jẹ́ {term}.',
    frasesBajaPasada: 'Mo ní ìṣòro láti pe orúkọ rẹ̀. Bóyá {term}?',
    frasesMediaPasada: 'Mo rò pé mo rí {term} níbí lẹ́ẹ̀kan.',
    frasesAltaPasada: 'Mo jẹ́ dájú díẹ̀ pé èyí jẹ́ {term}.',
    umbralBaja: '0-40% · kékeré',
    umbralMedia: '40-70% · àárín',
    umbralAlta: '70-100% · gíga',
    modoArchivo: 'Ibi-ipamọ',
    modoRastro: 'Ipa-ọ̀nà',
    volverArchivo: '← padà sí ibi-ipamọ',
    enOtrasLenguas: 'ní àwọn èdè míràn',
    sinImagenes: 'Kò sí àwọn àwòrán tí a kó fún ẹ̀ka yìí.',
    cargandoVocabulario: 'Ń gba ọ̀rọ̀ — àwọn ọ̀rọ̀ 80 láti sọ orúkọ ayé...',
    maquinaLista: 'Ẹ̀rọ náà ti ṣetán. Ń bẹrẹ ibi-ipamọ...',
    cargandoArchivo: 'Ń kó fáìlì: {nombre}',
    observando: 'Ń ṣàkíyèsí...',
    presionarPlay: 'Tẹ play láti bẹ̀rẹ̀.',
  },

  ha: {
    frasesBaja: 'Ina wahala wajen sanya suna. Wataƙila {term}?',
    frasesMedia: 'Ina tsammani ina ganin {term} a nan.',
    frasesAlta: 'Na tabbata cewa wannan shine {term}.',
    frasesBajaPasada: 'Na sami wahala wajen sanya suna. Wataƙila {term}?',
    frasesMediaPasada: 'Na tsammani na ga {term} a nan.',
    frasesAltaPasada: 'Na tabbata cewa na ga {term}.',
    umbralBaja: '0-40% · ƙasa',
    umbralMedia: '40-70% · tsakiya',
    umbralAlta: '70-100% · sama',
    modoArchivo: 'Ajiya',
    modoRastro: 'Sawun-ƙafa',
    volverArchivo: '← koma ajiya',
    enOtrasLenguas: 'a wasu harsunan',
    sinImagenes: 'Babu hotuna da aka loda don wannan rukuni.',
    cargandoVocabulario: 'Ana loda kalmomi — kalmomi 80 don suna duniya...',
    maquinaLista: "Na'ura ta shirya. Ana fara ajiya...",
    cargandoArchivo: 'Ana loda fayil: {nombre}',
    observando: 'Ana lura...',
    presionarPlay: 'Danna play don fara.',
  },

  am: {
    frasesBaja: 'ሊሰይምለት ይቸግረኛል። ምናልባት {term}?',
    frasesMedia: 'እዚህ {term} እያየሁ ይመስለኛል።',
    frasesAlta: 'ይህ {term} ነው ብዬ እርግጠኛ ነኝ።',
    frasesBajaPasada: 'ሊሰይምለት ተቸግሬ ነበር። ምናልባት {term}?',
    frasesMediaPasada: '{term} ያየሁ ብዬ አስቤ ነበር።',
    frasesAltaPasada: 'ይህ {term} ነበር ብዬ እርግጠኛ ነበርኩ።',
    umbralBaja: '0-40% · ዝቅተኛ',
    umbralMedia: '40-70% · መካከለኛ',
    umbralAlta: '70-100% · ከፍተኛ',
    modoArchivo: 'ማህደር',
    modoRastro: 'ምልክት',
    volverArchivo: '← ወደ ማህደሩ ተመለስ',
    enOtrasLenguas: 'በሌሎች ቋንቋዎች',
    sinImagenes: 'ለዚህ ምድብ የተጫኑ ምስሎች የሉም።',
    cargandoVocabulario: 'መዝገበ ቃላት እየጫነ — ዓለምን ለመሰየም 80 ቃላት...',
    maquinaLista: 'ማሽኑ ዝግጁ ነው። ማህደር እያስነሳ...',
    cargandoArchivo: 'ፋይል እየጫነ: {nombre}',
    observando: 'እያስተዋለ...',
    presionarPlay: 'ለመጀመር play ይጫኑ።',
  },

  zu: {
    frasesBaja: 'Ngikhó nzima ukuliphongola igama. Mhlawumbe {term}?',
    frasesMedia: 'Ngicabanga ukuthi ngibona {term} lapha.',
    frasesAlta: 'Ngiqinisekile ukuthi lokhu kuyí {term}.',
    frasesBajaPasada: 'Ngaluthola kunzima ukuliphongola igama. Mhlawumbe {term}?',
    frasesMediaPasada: 'Ngacabanga ukuthi ngabona {term} lapha.',
    frasesAltaPasada: 'Ngaqiniseka ukuthi lokhu kwakuyi {term}.',
    umbralBaja: '0-40% · phansi',
    umbralMedia: '40-70% · phakathi',
    umbralAlta: '70-100% · phezulu',
    modoArchivo: 'Ilondolozo',
    modoRastro: 'Umkhondo',
    volverArchivo: '← buyela ekulondolozweni',
    enOtrasLenguas: 'ngezinye izilimi',
    sinImagenes: 'Azikho izithombe ezilodiwe kulo mkhakha.',
    cargandoVocabulario: 'Ilayisha amagama — amagama angu-80 okubiza umhlaba...',
    maquinaLista: 'Umshini uselungele. Iqala ukulondoloza...',
    cargandoArchivo: 'Ilayisha ifayela: {nombre}',
    observando: 'Ukubheka...',
    presionarPlay: 'Cindezela u-play ukuze uqale.',
  },

  ar: {
    frasesBaja: 'أجد صعوبة في تسميته. ربما {term}؟',
    frasesMedia: 'أعتقد أنني أرى {term} هنا.',
    frasesAlta: 'أنا متأكد إلى حد ما أن هذا {term}.',
    frasesBajaPasada: 'وجدت صعوبة في تسميته. ربما كان {term}؟',
    frasesMediaPasada: 'اعتقدت أنني رأيت {term} هنا.',
    frasesAltaPasada: 'كنت متأكداً إلى حد ما أن هذا كان {term}.',
    umbralBaja: '0-40% · منخفض',
    umbralMedia: '40-70% · متوسط',
    umbralAlta: '70-100% · مرتفع',
    modoArchivo: 'الأرشيف',
    modoRastro: 'الأثر',
    volverArchivo: '← العودة إلى الأرشيف',
    enOtrasLenguas: 'بلغات أخرى',
    sinImagenes: 'لا توجد صور محملة لهذه الفئة.',
    cargandoVocabulario: 'تحميل المفردات — 80 كلمة لتسمية العالم...',
    maquinaLista: 'الآلة جاهزة. بدء الأرشيف...',
    cargandoArchivo: 'تحميل الملف: {nombre}',
    observando: 'مراقبة...',
    presionarPlay: 'اضغط تشغيل للبدء.',
  },

  hi: {
    frasesBaja: 'मुझे इसे नाम देने में कठिनाई है। शायद {term}?',
    frasesMedia: 'मुझे लगता है कि मैं यहाँ {term} देख रहा हूँ।',
    frasesAlta: 'मुझे काफी विश्वास है कि यह {term} है।',
    frasesBajaPasada: 'मुझे इसे नाम देने में कठिनाई हुई। शायद {term}?',
    frasesMediaPasada: 'मुझे लगा कि मैंने यहाँ {term} देखा।',
    frasesAltaPasada: 'मुझे काफी विश्वास था कि यह {term} था।',
    umbralBaja: '0-40% · निम्न',
    umbralMedia: '40-70% · मध्यम',
    umbralAlta: '70-100% · उच्च',
    modoArchivo: 'संग्रह',
    modoRastro: 'अनुरेख',
    volverArchivo: '← संग्रह में वापस',
    enOtrasLenguas: 'अन्य भाषाओं में',
    sinImagenes: 'इस श्रेणी के लिए कोई चित्र नहीं मिला।',
    cargandoVocabulario: 'शब्दावली लोड हो रही है — दुनिया का नाम लेने के लिए 80 शब्द...',
    maquinaLista: 'मशीन तैयार है। संग्रह शुरू हो रहा है...',
    cargandoArchivo: 'फ़ाइल लोड हो रही है: {nombre}',
    observando: 'देख रहा है...',
    presionarPlay: 'शुरू करने के लिए play दबाएं।',
  },

  qu: {
    frasesBaja: 'Suticharqayta atinichu. Ichapis {term}?',
    frasesMedia: 'Kaypi {term} rikuni nini.',
    frasesAlta: 'Kay {term} kasqanmanta yachani.',
    frasesBajaPasada: 'Suticharqayta mana atiysaq karan. Ichapis {term}?',
    frasesMediaPasada: 'Kaypi {term} rikurqani.',
    frasesAltaPasada: 'Kay {term} kasqanta yacharqani.',
    umbralBaja: "0-40% · huch'uy",
    umbralMedia: '40-70% · chawpi',
    umbralAlta: '70-100% · hatun',
    modoArchivo: 'Qillqasqa',
    modoRastro: 'Kichkasqa',
    volverArchivo: '← qillqasqaman kutiy',
    enOtrasLenguas: 'suk rimaykuna ukhupi',
    sinImagenes: "Mana rikuchisqa llanq'ay kay kutipi.",
    cargandoVocabulario: 'Rimaykuna haykuchishani — 80 rimaykuna pachamanta sutichanapaq...',
    maquinaLista: 'Maquina lista. Qillqasqa qallarishani...',
    cargandoArchivo: 'Archivo haykuchishani: {nombre}',
    observando: 'Qhawashani...',
    presionarPlay: 'Play nuqaychay qallariy.',
  },

  gn: {
    frasesBaja: "Neirundéi ñe'ẽ chupe. Avave {term}?",
    frasesMedia: 'Ahecha {term} kópe.',
    frasesAlta: 'Añeê ko {term} peva.',
    frasesBajaPasada: "Neirundéi ñe'ẽ chupe. Avave {term}?",
    frasesMediaPasada: "Ahecha {term} kópe araka'e.",
    frasesAltaPasada: "Añeê ko {term} peva araka'e.",
    umbralBaja: '0-40% · michĩ',
    umbralMedia: '40-70% · mbyte',
    umbralAlta: '70-100% · tuicha',
    modoArchivo: "Ñe'ẽnga",
    modoRastro: 'Rape',
    volverArchivo: "← jey ñe'ẽngápe",
    enOtrasLenguas: "ambue ñe'ẽme",
    sinImagenes: "Ndaipóri ta'ãnga oñemohendáva ko categoriapegua.",
    cargandoVocabulario: "Oñemohendá ñe'ẽ — 80 ñe'ẽ yvy oñeñe'ẽmba'apo...",
    maquinaLista: "Máquina oñemohendáma. Oñepyrũ ñe'ẽnga...",
    cargandoArchivo: 'Oñemohendá archivo: {nombre}',
    observando: 'Ohecha...',
    presionarPlay: 'Ehopa play oñepyrũvo.',
  },

  nah: {
    frasesBaja: 'Nixtlapaloa itocar. Cuix {term}?',
    frasesMedia: 'Nimati niquitta {term} nicān.',
    frasesAlta: 'Neltia niyoltia ca inin {term}.',
    frasesBajaPasada: 'Nixtlapaloa itocar. Cuix {term}?',
    frasesMediaPasada: 'Onimati oniquitta {term} nicān.',
    frasesAltaPasada: 'Oniltia oniyoltia ca inin {term} okatca.',
    umbralBaja: '0-40% · tepiton',
    umbralMedia: '40-70% · tlamamani',
    umbralAlta: '70-100% · huehca',
    modoArchivo: 'Tlapohualli',
    modoRastro: 'Ixhuapilli',
    volverArchivo: '← ximohuiqui tlapohuallipan',
    enOtrasLenguas: 'oc cē tlahtol',
    sinImagenes: 'Ahmo tlacuilolli mosencauhqui inin categoriapan.',
    cargandoVocabulario: 'Motequitia tlahtōl — 80 tlahtōl itocayotzin cemanahuatl...',
    maquinaLista: 'Tlapohualoni monextia. Motequitia tlapohualli...',
    cargandoArchivo: 'Motequitia archivo: {nombre}',
    observando: 'Moittaz...',
    presionarPlay: 'Xiquitztemo play motequitiz.',
  },

  zh: {
    frasesBaja: '我很难说出它的名字。也许是 {term}？',
    frasesMedia: '我想我在这里看到了 {term}。',
    frasesAlta: '我相当确定这是 {term}。',
    frasesBajaPasada: '我很难说出它的名字。也许曾经是 {term}？',
    frasesMediaPasada: '我想我曾在这里看到了 {term}。',
    frasesAltaPasada: '我相当确定这曾经是 {term}。',
    umbralBaja: '0-40% · 低',
    umbralMedia: '40-70% · 中',
    umbralAlta: '70-100% · 高',
    modoArchivo: '档案',
    modoRastro: '轨迹',
    volverArchivo: '← 返回档案',
    enOtrasLenguas: '用其他语言',
    sinImagenes: '此类别没有加载的图像。',
    cargandoVocabulario: '正在加载词汇 — 80个词语命名世界...',
    maquinaLista: '机器已准备好。正在启动档案...',
    cargandoArchivo: '正在加载文件：{nombre}',
    observando: '正在观察...',
    presionarPlay: '按下播放开始。',
  },

  en: {
    frasesBaja: "I'm struggling to name this. Perhaps {term}?",
    frasesMedia: 'I think I see {term} here.',
    frasesAlta: "I'm fairly certain this is {term}.",
    frasesBajaPasada: 'I struggled to name this. Perhaps {term}?',
    frasesMediaPasada: 'I thought I saw {term} here.',
    frasesAltaPasada: 'I was fairly certain this was {term}.',
    umbralBaja: '0-40% · low',
    umbralMedia: '40-70% · medium',
    umbralAlta: '70-100% · high',
    modoArchivo: 'Archive',
    modoRastro: 'Trace',
    volverArchivo: '← back to archive',
    enOtrasLenguas: 'in other languages',
    sinImagenes: 'No images loaded for this category.',
    cargandoVocabulario: 'Loading vocabulary — 80 words to name the world...',
    maquinaLista: 'The machine is ready. Starting archive...',
    cargandoArchivo: 'Loading file: {nombre}',
    observando: 'Observing...',
    presionarPlay: 'Press play to begin.',
  },
};

/** Idiomas disponibles para la interfaz de usuario (incluye inglés, que no está en el panel de traducciones). */
export const idiomasUI: Record<string, string> = {
  am: 'Amharic — አማርኛ',
  ar: 'العربية',
  en: 'English',
  es: 'Español',
  fr: 'Français',
  gn: 'Guaraní',
  ha: 'Hausa',
  hi: 'हिन्दी',
  zu: 'isiZulu',
  kg: 'Kikongo',
  rw: 'Kinyarwanda',
  sw: 'Kiswahili',
  ln: 'Lingala',
  nah: 'Náhuatl',
  pt: 'Português',
  qu: 'Quechua',
  yo: 'Yorùbá',
  zh: '中文',
};
